export default "<div id=\"cover-spin\"></div>\n\n<router-outlet></router-outlet>\n";